import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './RectanglesOptions.css';

class RectanglesOptions extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.number).isRequired,
    selected: PropTypes.number.isRequired,
    name: PropTypes.string,
    postfix: PropTypes.string,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    title: 'term',
    name: 'term',
    postfix: '',
    disabled: false,
    onChange: () => {},
  };

  Optoin = item => {
    const { disabled, selected, onChange, name, postfix } = this.props;
    return (
      <div
        key={item}
        className={cx(s.item, {
          [s.selected]: selected === item,
          [s.disabled]: disabled,
        })}
        onClick={() => (disabled ? null : onChange(name, item))}
      >
        {item}
        {postfix}
      </div>
    );
  };

  render() {
    return (
      <div className={s.root}>
        {this.props.options.map(this.Optoin)}
      </div>
    );
  }
}

export default withStyles(s)(RectanglesOptions);



// WEBPACK FOOTER //
// ./src/shared/components/UI/RectanglesOptions/RectanglesOptions.js